import Menu from "orser-model/Menu";
import Ordine from "../mapper/Ordine";
import { OrdineSingolo } from "../mapper/OrdineSingolo";
import { Ristorante } from "../mapper/Ristorante";
import servicesProvider from "./ServicesProvider";

export class OrdineService {

    async addNewStateToOrdineSingoloAndUpdateOrdineFromCucina(ristoranteId: string, clienteId: string, ordine: Ordine, ordineSingolo: OrdineSingolo, activeMenu?: Menu) {
        if (ordineSingolo.statoCompletamento.length !== 0) {
            let lastStatoCompletamento = ordineSingolo.statoCompletamento[ordineSingolo.statoCompletamento.length - 1];
            if (lastStatoCompletamento.stato === 1) {
                return;
            }
        }

        let hasPassFromMenu = false;
        if (activeMenu) {
            hasPassFromMenu = activeMenu.sezioneList.some(sezione =>
                sezione.menuSezioneArticoloList.some(menuArticolo =>
                    menuArticolo.hasPass && menuArticolo.articoloId?.toString() === ordineSingolo.articoloId
                )
            );
        }

        console.log(ordineSingolo);

        if (hasPassFromMenu) {
            ordineSingolo.statoCompletamento.push({
                date: new Date(),
                stato: 1
            });
        } else {
            ordineSingolo.statoCompletamento.push({
                date: new Date(),
                stato: 2
            });
        }


        console.log(ordineSingolo);
        if (this.isAllOrdiniSingoliCompletati(ordine)) {
            ordine.statoCompletamento = 1;
        }

        this.updateOrdine(clienteId, ordine);
    }

    async addNewStateToOrdineSingoloAndUpdateOrdineFromPass(ristoranteId: string, clienteId: string, ordine: Ordine, ordineSingolo: OrdineSingolo) {
        if (ordineSingolo.statoCompletamento.length !== 0) {
            let lastStatoCompletamento = ordineSingolo.statoCompletamento[ordineSingolo.statoCompletamento.length - 1];
            if (lastStatoCompletamento.stato === 2 || lastStatoCompletamento.stato === 0) {
                return;
            }
        }

        ordineSingolo.statoCompletamento.push({
            date: new Date(),
            stato: 2
        });

        if (this.isAllOrdiniSingoliCompletati(ordine)) {
            ordine.statoCompletamento = 1;
        }

        this.updateOrdine(clienteId, ordine);
    }

    isAllOrdiniSingoliCompletati(ordine: Ordine): boolean {
        let foundOrdineNonCompletato = false;
        ordine.ordineSingoloList.forEach(ord => {
            if (ord.statoCompletamento.length === 0) {
                foundOrdineNonCompletato = true;
                return;
            }

            let lastStatoCompletamento = ord.statoCompletamento[ord.statoCompletamento.length - 1];
            if (lastStatoCompletamento.stato == 0) {
                foundOrdineNonCompletato = true;
            }
        });
        return !foundOrdineNonCompletato;
    }

    updateOrdine(clienteId: string, ordine: Ordine) {
        servicesProvider.getOrdineDbQueries().updateByClienteIdAndOrdine(clienteId, ordine);
    }

    async completeOrdineFromCucinaAndUpdate(ristoranteId: string, clienteId: string, ordine: Ordine) {
        for (let ordineSingolo of ordine.ordineSingoloList) {
            let lastStatoCompletamentoOpt = ordineSingolo.getLastStatoCompletamento();
            if (lastStatoCompletamentoOpt !== null && lastStatoCompletamentoOpt.stato === 1) {
                continue;
            }

            //let piatto: Piatto = await servicesProvider.getPiattoService().getPiattoById(ristoranteId, ordineSingolo.piattoId);
            let ristorante: Ristorante = await servicesProvider.getRistoranteService().getRistoranteById(ristoranteId);
            //let hasPass = ristorante.tipologie.find(tipologia => tipologia.nome === piatto.sezioneMenu)?.hasPass;

            ordineSingolo.statoCompletamento.push({
                date: new Date(),
                stato: 1
            });

            /*if (hasPass) {
                ordineSingolo.statoCompletamento.push({
                    date: new Date(),
                    stato: 1
                });
            } else {
                ordineSingolo.statoCompletamento.push({
                    date: new Date(),
                    stato: 2
                });
            }*/
        }

        if (this.isAllOrdiniSingoliCompletati(ordine)) {
            ordine.statoCompletamento = 1;
        }

        this.updateOrdine(clienteId, ordine);
    }

    async goBackStateToOrdineSingoloAndUpdate(ristoranteId: string, clienteId: string, ordine: Ordine, ordineSingolo: OrdineSingolo) {
        let lastStatoCompletamento = ordineSingolo.getLastStatoCompletamento();
        if (!lastStatoCompletamento || lastStatoCompletamento?.stato === 0) {
            return;
        }

        //let piatto: Piatto = await servicesProvider.getPiattoService().getPiattoById(ristoranteId, ordineSingolo.piattoId);
        let ristorante: Ristorante = await servicesProvider.getRistoranteService().getRistoranteById(ristoranteId);
        //let hasPass = ristorante.tipologie.find(tipologia => tipologia.nome === piatto.sezioneMenu)?.hasPass;

        ordineSingolo.statoCompletamento.push({
            date: new Date(),
            stato: lastStatoCompletamento.stato - 1
        });

        /*if (!hasPass && lastStatoCompletamento.stato == 2) {
            ordineSingolo.statoCompletamento.push({
                date: new Date(),
                stato: lastStatoCompletamento.stato - 2
            });
        } else {
            ordineSingolo.statoCompletamento.push({
                date: new Date(),
                stato: lastStatoCompletamento.stato - 1
            });
        }*/

        if (this.isAllOrdiniSingoliCompletati(ordine)) {
            ordine.statoCompletamento = 1;
        } else {
            ordine.statoCompletamento = 0;
        }

        this.updateOrdine(clienteId, ordine);
    }
}